import { render } from "./ReportsTab.vue?vue&type=template&id=17a90f35&scoped=true"
import script from "./ReportsTab.vue?vue&type=script&lang=js"
export * from "./ReportsTab.vue?vue&type=script&lang=js"

import "./ReportsTab.vue?vue&type=style&index=0&id=17a90f35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a90f35"]])

export default __exports__